import {
  REFERENCE_LIST_FETCH,
  REFERENCE_LIST_SUCCESS,
  REFERENCE_LIST_FAILURE
} from './actionTypes';

import { ADD_REFERENCE_TO_THE_LIST } from '../ReferenceForm/actionTypes';

const initialState = {
  isLoaded: false,
  references: [],
  error: []
};

export const referencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case REFERENCE_LIST_FETCH:
      return { ...state, isLoaded: false };
    case REFERENCE_LIST_SUCCESS:
      return { ...state, isLoaded: true, references: action.payload };
    case ADD_REFERENCE_TO_THE_LIST:
      return {
        ...state,
        isLoaded: true,
        references: [...state.references, action.payload]
      };
    case REFERENCE_LIST_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isLoaded = state => state.referenceList.isLoaded;
export const getReferences = state => state.referenceList.references;
export const getError = state => state.referenceList.error;



// WEBPACK FOOTER //
// ./src/modules/ReferenceList/reducer.js